import React from "react";
import styles from "./Viewport.module.css";

/**
 * Wrapper for the entire screen
 * @returns
 */
const ViewPort = ({
  children,
  ...props
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  return (
    <div {...props} className={styles.viewport}>
      {children}
    </div>
  );
};

export default ViewPort;
